document.addEventListener('DOMContentLoaded', () => {
    const sidebarToggle = document.getElementById('sidebarToggle');
    
    // Restore state immediately to prevent flash if possible, 
    // though DOMContentLoaded might be slightly late for that.
    // Ideally this script runs early.
    const isCollapsedStored = localStorage.getItem('sidebar-collapsed') === 'true';
    if (isCollapsedStored) {
        document.body.classList.add('sidebar-collapsed');
    }

    if (sidebarToggle) {
        sidebarToggle.addEventListener('click', (e) => {
            e.preventDefault();
            document.body.classList.toggle('sidebar-collapsed');
            
            // Persist state
            const isCollapsed = document.body.classList.contains('sidebar-collapsed');
            localStorage.setItem('sidebar-collapsed', String(isCollapsed));
        });
    }

    // Handle clicks on parent menu items when collapsed
    const parentLinks = document.querySelectorAll('.sidebar .nav-link[data-bs-toggle="collapse"]');
    parentLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            if (document.body.classList.contains('sidebar-collapsed')) {
                // Expand sidebar first
                document.body.classList.remove('sidebar-collapsed');
                localStorage.setItem('sidebar-collapsed', 'false');
                
                // The default behavior (Bootstrap collapse toggle) will continue
                // and toggle the submenu.
            }
        });
    });
});
